import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';

export class LockedUnlockedBalance implements Deserializable {
  public memberId!: number;
  public governingJurisdictionId!: GoverningJurisdictionTypeId | null;
  public governingJurisdiction!: GoverningJurisdictionType | null;
  public lockedInBalance!: number;
  public unlockedBalance!: number;
  public totalBalance!: number;

  public onDeserialize() {
    this.governingJurisdictionId = this.governingJurisdictionId ?? null;
    this.governingJurisdiction = this.governingJurisdiction
      ? window.injector.Deserialize.instanceOf(GoverningJurisdictionType, this.governingJurisdiction)
      : null;
  }
}
